var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('h1',{staticClass:"error-type"},[_vm._v("404")]),_vm._v(" "),_c('h2',{staticClass:"error-message"},[_vm._v("That page does not exist.")])])
}]

export { render, staticRenderFns }